import React from 'react';
import Card from './card';

export default function FlavourFanatic() {
  return (
    <div className="benjerrys">
      <Card
        title="Flavour Fanatic"
        className="flavor-fanatic"
      />
    </div>
  );
}
